var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { put, call, takeLatest } from 'redux-saga/effects';
import { fromJS } from 'immutable';
import history from '@store/history';
import { pageSize } from '@shared/utils/constants';
import errorHandler from 'services/connection';
import store from 'store';
import { getArticle as getArticleAction, getArticleComplete, getArticlesComplete, getArticlesCompleteSearch, getArticles as getArticlesAction, resetArticles, searchArticleComplete, articleNotFound, scanError, } from './actions';
var currency = store.get('currency') || 'EUR';
/* NEED-329 / NEED-330 */
var regexScan = new RegExp(/^\*(EA)?[0-9]+$/gm);
export function getArticles(api, action) {
    var footId, _a, body, headers, error_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!(action.payload.page === 1)) return [3 /*break*/, 2];
                return [4 /*yield*/, put(resetArticles())];
            case 1:
                _b.sent();
                _b.label = 2;
            case 2:
                _b.trys.push([2, 5, , 7]);
                footId = store.get('footId');
                return [4 /*yield*/, call([api, api.get], 'v2/article-search', {
                        params: __assign(__assign({ pageSize: 25 }, action.payload), { currency: currency, footId: footId }),
                    })];
            case 3:
                _a = _b.sent(), body = _a.body, headers = _a.headers;
                return [4 /*yield*/, put(getArticlesComplete(body, headers))];
            case 4:
                _b.sent();
                return [3 /*break*/, 7];
            case 5:
                error_1 = _b.sent();
                return [4 /*yield*/, put(errorHandler(error_1, getArticlesComplete, getArticlesAction, action.payload))];
            case 6:
                _b.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
export function getArticle(api, action) {
    var footId, body, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                footId = store.get('footId');
                return [4 /*yield*/, call([api, api.get], "articles/" + action.payload, {
                        params: { currency: currency, footId: footId },
                    })];
            case 1:
                body = (_a.sent()).body;
                return [4 /*yield*/, put(getArticleComplete(fromJS(__assign(__assign({}, body), { singleLoaded: true }))))];
            case 2:
                _a.sent();
                return [3 /*break*/, 4];
            case 3:
                error_2 = _a.sent();
                errorHandler(error_2, getArticleComplete, getArticleAction, action.payload);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}
/**
 * Fetches results for the search query by identifying if it's a scan code or some textsearch.
 *
 * @param api - Appropriate api end point.
 * @param action - Appropriate action.
 * @returns {IterableIterator<*>} IterableIterator.
 */
export function searchArticle(api, action) {
    var _a, page, scan, sanitizedPage, _b, body, headers, error_3;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 10, , 12]);
                _a = action.payload, page = _a.page, scan = _a.scan;
                sanitizedPage = void 0;
                try {
                    sanitizedPage = parseInt(sanitizedPage);
                }
                catch (e) {
                    sanitizedPage = 1;
                }
                return [4 /*yield*/, call([api, api.get], 'v2/articles/matching', {
                        params: {
                            text: scan,
                            pageSize: pageSize,
                            page: page || 1,
                        },
                    })];
            case 1:
                _b = _c.sent(), body = _b.body, headers = _b.headers;
                if (!((body === null || body === void 0 ? void 0 : body.content.length) === 1)) return [3 /*break*/, 4];
                return [4 /*yield*/, call(history.push, "/articles/" + body.content[0].articleId)];
            case 2:
                _c.sent();
                return [4 /*yield*/, put(searchArticleComplete(fromJS(__assign(__assign({}, body.content[0]), { singleLoaded: true }))))];
            case 3:
                _c.sent();
                return [3 /*break*/, 9];
            case 4:
                if (!((body === null || body === void 0 ? void 0 : body.content.length) > 1)) return [3 /*break*/, 7];
                return [4 /*yield*/, call(history.push, "/scan/results?text=" + scan)];
            case 5:
                _c.sent();
                return [4 /*yield*/, put(getArticlesCompleteSearch(fromJS(body.content), headers))];
            case 6:
                _c.sent();
                return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, put(articleNotFound())];
            case 8:
                _c.sent();
                _c.label = 9;
            case 9: return [3 /*break*/, 12];
            case 10:
                error_3 = _c.sent();
                return [4 /*yield*/, put(scanError())];
            case 11:
                _c.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
export function getArticlesWatcher(_a) {
    var api = _a.api;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, takeLatest('GET_ARTICLES', getArticles, api)];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export function getArticleWatcher(_a) {
    var api = _a.api;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, takeLatest('GET_ARTICLE', getArticle, api)];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export function searchArticleWatcher(_a) {
    var api = _a.api;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, takeLatest('SEARCH_ARTICLE', searchArticle, api)];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
